module.exports = __webpack_public_path__ + "static/xcg-065a8ac8c9320bd7ada83a71c80ea2dc.png";